import { render, staticRenderFns } from "./PageFooterSponsorOrPartnerMobileView.vue?vue&type=template&id=fcd7cee2"
import script from "./PageFooterSponsorOrPartnerMobileView.vue?vue&type=script&lang=js"
export * from "./PageFooterSponsorOrPartnerMobileView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports